import { Loader2, Search } from 'lucide-react';

type EmptyStateMode = 'empty' | 'loading';

interface EmptyStateProps {
  mode?: EmptyStateMode;
  title?: string;
  description?: string;
  loadingTitle?: string;
  loadingDescription?: string;
}

export default function EmptyState({
  mode = 'empty',
  title,
  description,
  loadingTitle,
  loadingDescription,
}: EmptyStateProps) {
  const loading = mode === 'loading';
  const displayTitle = loading
    ? (loadingTitle ?? 'Investigation working')
    : (title ?? 'Investigation Workspace');
  const displayDescription = loading
    ? (loadingDescription ??
      'Zoe is reviewing your question against the truth layer. You will get a structured answer with evidence and a timeline shortly.')
    : (description ?? 'Ask a question to begin your investigation.');

  return (
    <div className="flex flex-col items-center justify-center h-full min-h-100 text-center px-8">
      <div
        className={`w-16 h-16 rounded-full border flex items-center justify-center mb-4 ${
          loading
            ? 'bg-success/10 border-success/30'
            : 'bg-card border-border'
        }`}
      >
        {loading ? (
          <Loader2 className="w-7 h-7 text-success animate-spin" aria-hidden />
        ) : (
          <Search className="w-7 h-7 text-muted-foreground" aria-hidden />
        )}
      </div>
      <h2 className="text-lg font-medium text-foreground mb-2">{displayTitle}</h2>
      <p className="text-sm text-muted-foreground max-w-md leading-relaxed">{displayDescription}</p>
    </div>
  );
}
